<template>
<div class="chapter">
<div class="inner_page">
<p class="p6"><span class="t7">Copyright</span></p>
<p class="p6"><span class="t5">Published by</span></p>
<p class="p6"><span class="t5">Dreamspinner Press</span></p>
<p class="p6"><span class="t5">4760 Preston Road</span></p>
<p class="p6"><span class="t5">Suite 244-149</span></p>
<p class="p6"><span class="t5">Frisco, TX 75034</span></p>
<p class="p6"><a href="http://www.dreamspinnerpress.com/" target="_blank"><span class="t8">http://www.dreamspinnerpress.com/</span></a></p>
<p class="p6"><span class="t5"> </span></p>
<p class="p6"><span class="t5">This is a work of fiction. Names, characters, places, and incidents either are the product of the author’s imagination or are used fictitiously, and any resemblance to actual persons, living or dead, business establishments, events, or locales is entirely coincidental.</span></p>
<p class="p6"><span class="t5"> </span></p>
<p class="p6"><span class="t5">When Memory Fails</span></p>
<p class="p6"><span class="t5">Copyright © 2011 by D.W. Marchwell</span></p>
<p class="p6"><span class="t5"> </span></p>
<p class="p6"><span class="t5">Cover Art by Anne Cain    </span><span class="t8">annecain.art@gmail.com</span></p>
<p class="p6"><span class="t5">Cover Design by Mara McKennen</span></p>
<p class="p6"><span class="t5"> </span></p>
<p class="p6"><span class="t5">All rights reserved. No part of this book may be reproduced or transmitted in any form or by any means, electronic or mechanical, including photocopying, recording, or by any information storage and retrieval system without the written permission of the Publisher, except where permitted by law. To request permission and all other inquiries, contact Dreamspinner Press, 4760 Preston Road, Suite 244-149, Frisco, TX 75034</span></p>
<p class="p6"><a href="http://www.dreamspinnerpress.com/" target="_blank"><span class="t8">http://www.dreamspinnerpress.com/</span></a></p>
<p class="p6"><span class="t5"> </span></p>
<p class="p6"><span class="t5">ISBN: 978-1-61372-138-4</span></p>
<p class="p6"><span class="t5"> </span></p>
<p class="p6"><span class="t5">Printed in the United States of America</span></p>
<p class="p6"><span class="t5">First Edition</span></p>
<p class="p6"><span class="t5">August 2011</span></p>
<p class="p6"><span class="t5"> </span></p>
<p class="p6"><span class="t5">eBook edition available</span></p>
<p class="p6"><span class="t5">eBook ISBN: 978-1-61372-139-1</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005.vue?5a18a893